import "./Bbps.css";
import Navbar from "./Bbpsnav";
import { useNavigate, useParams } from "react-router-dom";
import header_Logo from "../../assets/bbps/bharat_pay.png";
import React, { useState, useEffect } from "react";
import LoginServices from "../../services/LoginServices";
import { useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../spinner";
export default function Bbps() {
    const [spinner, setSpinner] = useState(false);
    const { type } = useParams();
    const [billdetails, setbilldetails] = useState<any>();
    const [billername, setbillername] = useState<any>(
        sessionStorage.getItem("billerName")
    );
    const [userIpAddress, setUserIpAddress] = useState("");

    let bill = sessionStorage.getItem("billdetails");
    const [amount, setamount] = useState<any>();
    const navigate = useNavigate();
    const userId = localStorage.getItem("userid");
    const componentMounted = useRef(true);

    useEffect(() => {
        setamount(Number(sessionStorage.getItem("amount")) / 100);
        if (bill) {
            setbilldetails(JSON.parse(bill));
            // console.log(JSON.parse(bill));
        }
    }, []);
    useEffect(() => {
        const id = document.getElementById("razorpayscript");
        console.log(id);
        if (!id) {
            const script = document.createElement("script");
            script.src = "https://checkout.razorpay.com/v1/checkout.js";
            script.async = true;
            script.id = "razorpayscript";
            document.body.appendChild(script);
        }

        fetch("https://api.ipify.org/?format=json")
            .then((Response) => {
                return Response.json();
            })
            .then((response) => {
                if (componentMounted.current) {
                    setUserIpAddress(response.ip);
                }
            })
            .catch((err) => {
                console.log(err);
            });

        return () => {
            // This code runs when component is unmounted
            componentMounted.current = false; // (4) set it to false when we leave the page
        };
    }, []);

    const amountChange = (e: any) => {
        setamount(e.target.value);
    };
    const payHandler = () => {
        let config = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        };

        if (type == "Fastag" && localStorage.getItem("userid") == "1111111") {
            const payload = {
                amount: Number(amount) * 100,
                mobileNumber: sessionStorage.getItem("usernumber"),
                emailId: "",
                notes: "",
                ipAddress: userIpAddress,
                paymentgateway: "pg1",
            };
            LoginServices.createRazorpayOrder(payload, config)
                .then((response: any) => {
                    if (response.data.Status == 1) {
                        window.open(response?.data?.PaymentLink, "_blank");
                        // startPaymentStatusCheck('');
                        // localStorage.setItem("receiptId", response.data.receiptId);
                        //orderId
                        // setOrderId1(response.data.orderId);
                        /*    if (props.Gateway == "pg1") {
                        options.key = process.env.REACT_APP_RAZORPAY_KEY;
                    } else if (props.Gateway == "pg2") {
                        options.key = process.env.REACT_APP_RAZORPAY_KEY_TWO;
                    }
                    options.amount =
                        parseFloat(props?.passBlc?.replace(/,/g, "")) * 100;
                    options.order_id = response.data.orderId;

                    if (userdetails) {
                        userdetails = JSON.parse(userdetails);
                        options.prefill = {
                            contact:
                                "+91" + parseInt(userdetails?.mobileNumber),
                            email: `${userdetails?.emailId}`,
                        };
                    }

                    var rzp1 = new (window as any).Razorpay(options);
                    rzp1.open(); */
                    } else if (response.data.Status == 0) {
                        setSpinner(false);
                        toast.error(`${response.data.Message}`, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((e: Error) => {
                    console.log(e);
                    setSpinner(false);
                });
            return;
        }
        setSpinner(true);

        const billerAdhoc = localStorage.getItem("billerAdhoc");
        let id = {};
        if (billerAdhoc) {
            id = {
                RequestID: billdetails?.RequestID,
            };
        }
        console.log(billdetails);
        let additionalInfo: any = [];
        if (billdetails?.BillDetails?.additionalInfo) {
            additionalInfo = [
                ...billdetails?.BillDetails?.additionalInfo?.info,
            ];
        }

        let data: any = {
            billerId: sessionStorage.getItem("billerid"),
            billerAdhoc: localStorage.getItem("billerAdhoc"),
            ...id,
            Amount: Number(amount) * 100,
            mobileNumber: sessionStorage.getItem("usernumber"),
            Params: {
                inputParams: {
                    input: [...billdetails?.BillDetails?.inputParams.input],
                },
                billerResponse: { ...billdetails?.BillDetails?.billerResponse },

                paymentMethod: {
                    paymentMode: "Wallet",
                    quickPay: "N",
                    splitPay: "N",
                },
                amountInfo: {
                    amount: Number(amount) * 100,
                    currency: "356",
                    custConvFee: "0",
                },
                paymentInfo: {
                    info: [
                        {
                            infoName: "WalletName",
                            infoValue: "Credit Mint Pvt Ltd",
                        },
                        {
                            infoName: "MobileNo",
                            infoValue: localStorage.getItem("mobilenumber"),
                        },
                    ],
                },
            },
        };
        if (additionalInfo?.length > 0) {
            data = {
                ...data,
                additionalInfo: {
                    additionalInfo,
                },
            };
        }
        console.log(data);
        // console.log("abcd", data);
        LoginServices.paybill(data, config)
            .then((response: any) => {
                setSpinner(false);
                if (response.data?.Status == 1) {
                    sessionStorage.setItem(
                        "success",
                        JSON.stringify(response?.data?.BillPayResponse)
                    );
                    navigate(`/dashboard/bbps/success/${type}`);
                } else if (response?.data.Status == 0) {
                    alert(response?.data?.Message);
                }
                // console.log(response);
            })
            .catch((err) => {
                // console.log(err.response);
                setSpinner(false);
                alert(err?.response?.data?.Message);
            });
    };
    return (
        <>
            {spinner && <Spinner />}

            <div className="row main-row">
                <div className="col-10 dashboard-right-back">
                    <div className="header-bbps">
                        <div className="BbpsWrapper">
                            <div className="Bbps-heading">
                                <p>BBPS</p>
                                <img src={header_Logo} alt="" />
                            </div>
                            {/* <div className="Bbps-Navbar">
                            <Navbar active="billpay" />
                        </div> */}
                            <div className="amount-wrapper">
                                <div className="amount-data">
                                    <label htmlFor="billername">
                                        Biller Name
                                    </label>
                                    <input
                                        type="text"
                                        placeholder={billername}
                                        disabled
                                    />
                                </div>
                                {billdetails?.BillDetails?.additionalInfo?.info?.map(
                                    (item: any) => {
                                        return (
                                            <div className="amount-data">
                                                <label htmlFor={item?.infoName}>
                                                    {item?.infoName}
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder={
                                                        item?.infoValue
                                                    }
                                                    disabled
                                                />
                                            </div>
                                        );
                                    }
                                )}
                                {billdetails?.BillDetails?.inputParams?.input?.map(
                                    (item: any) => {
                                        return (
                                            <div className="amount-data">
                                                <label
                                                    htmlFor={
                                                        item?.input?.paramName
                                                    }>
                                                    {item?.paramName}
                                                </label>
                                                <input
                                                    type="text"
                                                    placeholder={
                                                        item?.paramValue
                                                    }
                                                    disabled
                                                />
                                            </div>
                                        );
                                    }
                                )}
                                <div className="amount-data">
                                    <label htmlFor="due date">Due Date</label>
                                    <input
                                        type="text"
                                        placeholder={
                                            billdetails?.BillDetails
                                                ?.billerResponse?.dueDate
                                        }
                                        disabled
                                    />
                                </div>
                                <div className="amount-data">
                                    <label htmlFor="billAmount">
                                        bill Amount
                                    </label>
                                    <input
                                        type="number"
                                        value={amount}
                                        onChange={amountChange}
                                    />
                                </div>

                                <button onClick={payHandler}>Pay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    );
}
